import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyApi } from '../api/company.api';
import { CurrencyApi } from '../api/currency.api';
import { OperatorUserApi } from '../api/operator-user.api';
import {
  CompaniesPage,
  CompanyDetail,
  CompanyDetailPayload,
  CompanyOperatorUser,
  CompanySaveResult,
  Currency,
} from '../models/company.model';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  private readonly _companyApi = inject(CompanyApi);
  private readonly _currencyApi = inject(CurrencyApi);
  private readonly _operatorUserApi = inject(OperatorUserApi);

  public getAll(
    page?: number,
    limit?: number,
    search?: string,
  ): Observable<CompaniesPage> {
    return this._companyApi.getAll(page, limit, search);
  }

  public companyDetail(id: number): Observable<CompanyDetail> {
    return this._companyApi.companyDetail(id);
  }

  public saveCompany(
    payload: CompanyDetailPayload,
  ): Observable<CompanySaveResult> {
    return this._companyApi.saveCompany(payload);
  }

  public updateCompany(
    id: number,
    payload: CompanyDetailPayload,
  ): Observable<string> {
    return this._companyApi.updateCompany(id, payload);
  }

  public currencies(): Observable<Currency[]> {
    return this._currencyApi.currencies();
  }

  public operatorUsers(): Observable<CompanyOperatorUser[]> {
    return this._operatorUserApi.operatorUsers();
  }

  public deleteCompany(id: number): Observable<void> {
    return this._companyApi.deleteCompany(id);
  }
}
